export default __webpack_public_path__ + "static/media/BAKA_ikona_web_odabrano-02.d13a9c47.svg";